var map = {
	"./da.webp": "./src/assets/landing/exercise/da.webp",
	"./de.webp": "./src/assets/landing/exercise/de.webp",
	"./en.webp": "./src/assets/landing/exercise/en.webp",
	"./es-419.webp": "./src/assets/landing/exercise/es-419.webp",
	"./es.webp": "./src/assets/landing/exercise/es.webp",
	"./fr.webp": "./src/assets/landing/exercise/fr.webp",
	"./it.webp": "./src/assets/landing/exercise/it.webp",
	"./nb.webp": "./src/assets/landing/exercise/nb.webp",
	"./nl.webp": "./src/assets/landing/exercise/nl.webp",
	"./pl.webp": "./src/assets/landing/exercise/pl.webp",
	"./pt.webp": "./src/assets/landing/exercise/pt.webp",
	"./sv.webp": "./src/assets/landing/exercise/sv.webp",
	"./tr.webp": "./src/assets/landing/exercise/tr.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/landing/exercise sync recursive ^\\.\\/.*\\.webp$";